import { app } from '../../../../../app';

app.component('companyManageApplicationIntegrationDevelopersRemoveConfiguration', {
    templateUrl: require('./remove-configuration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/remove-configuration/remove-configuration.component.js